import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-not-implemented",
    styleUrls: ["./not-implemented.component.scss"],
    templateUrl: "./not-implemented.component.html"
})
export class FUINotImplementedComponent {
    @Input() public title: string;

    constructor() {
        this.title = "Not available";
    }
}
